import { createElement } from 'react'
import type { CSSProperties } from 'react'
import { icons } from 'lucide'

type IconNode = ReadonlyArray<[string, Record<string, unknown>]>

export interface IconProps {
  name: string
  size?: number
  strokeWidth?: number
  className?: string
  style?: CSSProperties
}

// Lucide zostaje wyłącznie dla akcji w treści: 18 px, stroke 1.75 (MAPA decyzja 6).
// Glify stanów i nawigacji mieszkają w ds/media/Glyph.tsx.
export default function Icon({ name, size = 18, strokeWidth = 1.75, className, style }: IconProps) {
  const node = (icons as Record<string, IconNode>)[name]
  if (!node) return null
  return createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size, height: size, viewBox: '0 0 24 24',
      fill: 'none', stroke: 'currentColor', strokeWidth,
      strokeLinecap: 'round', strokeLinejoin: 'round',
      className, style: { display: 'block', flexShrink: 0, ...style },
    },
    node.map(([tag, attrs], i) => createElement(tag, { key: i, ...attrs })),
  )
}
